import { Component, Input, OnInit} from '@angular/core';
import { ProjectService } from '../project.service';
import { Questionnaire } from '../../model/questionnaire';
import { Project } from '../../model/project';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Question } from '../../model/question';
import { Choice } from '../../model/choice';
import { Text } from '../../model/text';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';


@Component({
    moduleId: module.id,
    selector: 'questionnaire-project',
    templateUrl: './questionnaire-project.component.html'
})
export class QuestionnaireProjectComponent implements OnInit {
    @Input() project: Project;
    /*@ViewChild('modal')
    modal: BsModalComponent ;*/
    public submitted = false;
    public myOption = false;
    public mySelect = false;
    public myCheckbox = false;

    private addQuestion = false;
    private editQuestion = false;
    private supprimerQuestion = false;



    active = false;

    questionnaire: Questionnaire;
    types = ['text', 'combo', 'radio', 'photo', 'checkbox'];
    textInit = new Text('en', 'fr');
    obj ={
      'text' : '',
      'type' : this.types[0],
      'numero' : 4,
      'choices' : [new Choice()],
      'texts' :  this.textInit
    };
    model = new Question();

    // form to add choices in case of radio button type
    public myForm: FormGroup;

    // Constantes selon la langue
    public _addNewQuestion: string;
    public _numQuestion: string;
    public _questionText: string;
    public _typeQuestion: string;
    public _editQuestion: string;
    public _deleteQuestion: string;
    public title = '';
    private _langue = 0;


    constructor(private _projectService: ProjectService, private _fb: FormBuilder) {

    }

    ngOnInit() {

        if(this.project.questionnaires.length !==0) {
            this._projectService.getQuestionnaire(this.project.questionnaires[0].id)  // modif temporaire on prend le premier question mais on pourrais avoir plusieurs questionnaireProject par projet.
                .subscribe(
                    res => {
                        // console.log(this.questionnaireProject = res, console.log("Hello got questionanire"),console.log(this.questionnaireProject.languages));
                        this.questionnaire = res;

                        this.active = true;

                        console.log(this.questionnaire.languages);
                        this.myForm = this._fb.group({
                            text: ['', [Validators.required]],
                            type: [this.types[0]],
                            numero: [''],
                            choices: this._fb.array([
                                this.initChoice()
                            ]),
                            texts: this._fb.group({
                                textEn: ['', <any>Validators.required],
                                textFr: ['', <any>Validators.required]
                            })
                        });

                        /*for (const quest of this.questionnaireProject.questions) {
                            console.log(quest.texts.toString());
                        }*/


                        const num = this.questionnaire.questions.length;
                        this.title = this.model.no < num ? 'Edit Question' : 'New Question';
                        if (this.questionnaire.languages.indexOf('fr') !== -1 && this.questionnaire.languages.indexOf('en') !== -1) {
                            this._langue = 2;
                        }
                        if (this.questionnaire.languages.indexOf('fr') !== -1 && this.questionnaire.languages.indexOf.length === 1) {
                            this._langue = 1;
                        }

                        switch (this._langue) {

                            case 1:
                                this._addNewQuestion = 'Ajouter Question';
                                this._numQuestion = 'No.';
                                this._questionText = 'Question';
                                this._typeQuestion = 'Type';
                                this._editQuestion = 'Modifier';
                                this._deleteQuestion = 'supprimer';
                                break;
                            case 2:
                                this._addNewQuestion = 'Ajouter / Add';
                                this._numQuestion = 'No.';
                                this._questionText = 'Question';
                                this._typeQuestion = 'Type';
                                this._editQuestion = 'Modifier / edit';
                                this._deleteQuestion = 'supprimer / delete';
                                break;
                            default: // english
                                this._addNewQuestion = 'Add Question';
                                this._numQuestion = 'No.';
                                this._questionText = 'Question';
                                this._typeQuestion = 'Type';
                                this._editQuestion = 'Edit';
                                this._deleteQuestion = 'Delete';
                                break;
                        }
                    },
                    error => console.log(<any>error.toString()));
        }

                }


    callType(value) {
        switch (value) {
            case 'radio':
                this.myOption = true;
                this.mySelect = false;
                this.myCheckbox = false;
                break;
            case 'combo':
                this.mySelect = true;
                this.myCheckbox = false;
                this.myOption = false;
                break;
            case 'checkbox':
                this.mySelect = false;
                this.myCheckbox = true;
                this.myOption = false;
                break;
            default:
                this.myOption = false;
                this.mySelect = false;
                this.myCheckbox = false;
                break;
        }
    }


    // to initialize choices
    initChoice() {
        return this._fb.group({
            textEn: ['', Validators.required],
            textFr: ['', Validators.required]
        });
    }


    addOption() {
        const control = <FormArray>this.myForm.controls['choices'];
        control.push(this.initChoice());
    }

    removeOption(i: number) {
        const control = <FormArray>this.myForm.controls['choices'];
        control.removeAt(i);
    }

    save(modell) {
    }

    preNewQuestion() {
        this.title = 'New Question';
        this.addQuestion = true;
    }

    preUpdateQuestion() {
        this.title = 'Edit Question';
        this.editQuestion = true;
    }

    preDeleteQuestion() {
        this.supprimerQuestion = true;
    }

    onSubmitForm(myForm) {

    }

    updateQuestion(question) {
        alert(JSON.stringify(question));
        this.title = 'Edit Question';
    }

    newQuestion(myForm) {
        this.myOption = false;
        this.mySelect = false;
        this.myCheckbox = false;
        console.log(myForm.value.texts.textEn);
        console.log(myForm.value.choices);
        const obj = {
          'text' : myForm.value.text,
          'type' : myForm.value.type,
          'numero' : myForm.value.numero,
          'choices' : myForm.value.choices,
          'texts' : new Text(myForm.value.texts.textEn, myForm.value.texts.textFr )

        };
        this.model = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(obj,Question);



        console.log(this.model);
        this.questionnaire.questions.push(this.model);
        this.active = false;
        setTimeout(() => this.active = true, 0);
        this.submitted = false;
        this.onReset();
        // set num Questions
        for (let num = 0; num < this.questionnaire.questions.length; num++) {
            this.questionnaire.questions[num].no = num + 1;
        }
        // this.modal.close();
    }


    deleteQuestion(question) {
        if (confirm('Are you sure you want to delete question : ' + question.numero + '?')) {
            const index = this.questionnaire.questions.indexOf(question);
            // Here, with the splice method, we remove 1 object
            // at the given index.
            this.questionnaire.questions.splice(index, 1);

            // set num Questions
            for (let num = 0; num < this.questionnaire.questions.length; num++) {
                this.questionnaire.questions[num].no = num + 1;
            }

        }
    }

    onReset(): void { this.resetForm(); }

    resetForm(): void {
        this.myForm = this._fb.group({
            text: ['', [Validators.required]],
            type: [this.types[0]],
            numero: [''],
            choices: this._fb.array([
                this.initChoice()
            ]),
            texts: this._fb.group({
                textEn: new FormControl('', <any>Validators.required),
                textFr: new FormControl('', <any>Validators.required)
            })


        });


    }


}
